import { get } from 'lodash-es';

import { emptyArray } from 'ui-components/default-props/empty';
import type { LabelQueBatch, LabelQueErrorOrWarning, LabelQueState } from './label-que.types';
import type { RootState } from 'store/root-state';

export const selectIsOpen = (state: LabelQueState): boolean => get(state, 'isOpen', false);
export const selectBatches = (state: LabelQueState): LabelQueBatch[] => get(state, 'batches', emptyArray as LabelQueBatch[]);
export const selectSelectedBatches = (state: LabelQueState): string[] => get(state, 'selectedBatches', emptyArray as string[]);
export const selectFromProcessDate = (state: LabelQueState) => get(state, 'fromProcessDate', false);
export const selectPageSize = (state: LabelQueState) => get(state, 'pageSize', false);
export const selectIsLoading = (state: LabelQueState): boolean => get(state, 'isLoading', false);
export const selectWarnOrErrorByBatchId = (state: LabelQueState, props: { batchId: string }): LabelQueErrorOrWarning | undefined => {
  const { batchId } = props;
  const warnOrErrors = state.errorsAndWarnings || [];
  return warnOrErrors.find((err) => err.batchId === batchId);
};
export const selectIsLabelFetchingComplete = (state: LabelQueState): boolean => get(state, 'isLabelFetchComplete', false);

export const selectLabelQueIsOpen = (state: RootState): boolean => selectIsOpen(get(state, 'labelQue'));
export const selectLabelQueBatches = (state: RootState): LabelQueBatch[] => selectBatches(get(state, 'labelQue'));
export const selectLabelQueSelectedBatches = (state: RootState): string[] => selectSelectedBatches(get(state, 'labelQue'));
export const selectLabelQueFromProcessDate = (state: RootState) => selectFromProcessDate(get(state, 'labelQue'));
export const selectLabelQuePageSize = (state: RootState) => selectPageSize(get(state, 'labelQue'));
export const selectLabelQueIsLoading = (state: RootState): boolean => selectIsLoading(get(state, 'labelQue'));
export const selectLabelQueWarnOrErrorByBatchId = (state: RootState, props: { batchId: string }) =>
  selectWarnOrErrorByBatchId(get(state, 'labelQue'), props);
export const selectLabelQueIsLabelFetchingComplete = (state: RootState): boolean => selectIsLabelFetchingComplete(get(state, 'labelQue'));
